import type { Editor } from "./canvas";
import type { TLShapeId } from "@tldraw/tlschema";

type Size = { w: number; h: number };

/** A reference should leave room to compose, even on a small sheet or at high zoom. */
export function imageImportBounds(editor: Editor, parentId: string): Size {
  const viewport = editor.getViewportPageBounds();
  const parent = parentId.startsWith("shape:")
    ? editor.getShape(parentId as TLShapeId)
    : undefined;
  return {
    w: Math.min(
      240,
      viewport.w * 0.4,
      parent?.type === "sheet" ? parent.props.w / 3 : Infinity,
    ),
    h: Math.min(
      180,
      viewport.h * 0.4,
      parent?.type === "sheet" ? parent.props.h / 3 : Infinity,
    ),
  };
}

/** Change display geometry only; retain original pixels and avoid enlarging small images. */
export function fitImportedImage(source: Size, bounds: Size): Size {
  const scale = Math.min(1, bounds.w / source.w, bounds.h / source.h);
  return { w: source.w * scale, h: source.h * scale };
}
